'use strict';

var d3 = require('d3');
var topojson = require('topojson');
var _ = require('underscore');
var utils = require('./utils.js');

var Prerender = require('d3-pre');
var prerender = Prerender(d3);

var us = require('../data/us_low.json');


/* CREATE THE BASIC D3 MAP COMPONENTS */

var width = 1024,
    height = 600,
    centered;

var path = d3.geo.path()
  .projection(null);


prerender.start();

var svg = d3.select('.map').append('svg')
  .attr('width', width)
  .attr('height', height);

svg.append('rect')
  .attr('class', 'map-background')
  .attr('width', width)
  .attr('height', height)
  .on('click', reset);

var opacity = {
  min: 0.15,
  max: 0.85
}

var total_scale = d3.scale.linear()
  .domain(utils.getTotalLimits(us))
  .range([opacity.min, opacity.max]);

var cand_scale = d3.scale.linear()
  .range([opacity.min, opacity.max]);

var selected_candidates = ['rubio', 'cruz', 'trump', 'bush', 'christie'];

var zoom = 0;
var active = d3.select(null);


/* APPEND THE COUNTIES AND STATES */

var g = svg.append('g');

g.append('g')
.selectAll('path')
  .data(topojson.feature(us, us.objects.nation).features)
.enter().append('path')
  .attr('d', path)
  .attr('class', 'nation')

g.append('g')
  .attr('class', 'counties')
.selectAll('path')
  .data(topojson.feature(us, us.objects.counties).features)
.enter().append('path')
  .attr('d', path)
  .attr('class', function(d){
    return 'shape county county' + d.id;
  })
  .style('fill-opacity', function(d){
    return total_scale(+d.properties.total);
  })
  .style('fill', function(d){
    return candidateColor(d);
  })
  .on('click', function(d){
    clicked(d3.select('.state' + d.properties.state).datum());
  })
  .on('mouseover', function(){
    updateShareTable(this);
  })
  .on('mouseout', resetShareTable);

g.append('path')
  .datum(topojson.mesh(us, us.objects.states, function(a, b) {
    return a !== b;
  }))
  .attr('class', 'state-borders')
  .attr('d', path);

g.append('g')
  .attr('class', 'states')
.selectAll('path')
  .data(topojson.feature(us, us.objects.states).features)
.enter().append('path')
  .attr('d', path)
  .attr('class', function(d){
    return 'shape state state' + d.id;
  });



/* FUNCTION TO COLOR STATES */

function candidateColor(d) {

  // THINK ABOUT HOW WE'RE GOING TO HANDLE TIES

  var list = _.filter(d.properties.fb, function(candidate){
    return selected_candidates.indexOf(candidate.name) > -1;
  });

  var leader = list.length > 0 ? _.first(list).name : 'blank';

  return utils.candidate_colors[leader];

}


/* FUNCTION TO MAKE CHECKBOXES WORK */

_.each(_.keys(utils.candidate_colors), function(name) {
  d3.select('label.' + name)
    .style('color', utils.candidate_colors[name]);
})

d3.selectAll('input[type=checkbox]')
  .on('change', function(){

    var box = d3.select(this).property('value');
    var index = selected_candidates.indexOf(box);

    if(index > -1) {
      selected_candidates.splice(index, 1);
    } else {
      selected_candidates.push(box);
    }

    if(selected_candidates.length === 1){
      cand_scale.domain(utils.getCandLimits(us, selected_candidates[0]));
    }

    d3.selectAll('.county')
      .style('fill', function(d){
        return candidateColor(d);
      })
      .style('fill-opacity', function(d){
        if(selected_candidates.length === 1) {

          var percent = _.filter(d.properties.fb, function(cand){
            return cand.name === selected_candidates[0];
          })[0].val;

          return cand_scale(percent);

        } else {
          return total_scale(+d.properties.total);
        }
      })

      resetShareTable();
  });


/* TOOLTIP FUNCTION */

var us_data = d3.select('.nation').datum().properties.fb;

function tableMaker(selection) {

  var table_rows = _.template(
    '<tr class = "<%= activeCandidate(name, selected) %>" style = "color: <%= candidate_colors[name] %>">' +
    '<td class = "candidate"><%= fullName[name] %></td>' +
    '<td class = "share"><%= formatPercent(val) %></td>' +
    '<td class = "diff"><%= getDiff(name, val, us_data) %></td>' +
    '</tr>'
  );

  var table_compiled = '';

  _.each(selection.properties.fb, function(candidate){
    table_compiled += table_rows(_.extend(candidate, utils, {selected: selected_candidates}, {us_data: us_data}));
  });

  d3.select('#table-data').html(table_compiled);

}


function updateShareTable(context) {

  var d = d3.select(context).datum();
  d3.selectAll('.shape').style('stroke', 'none');

  var shape = zoom > 0 ? d3.select(context) : d3.select('.state' + d.properties.state);
  shape.style('stroke', '#3c3c3c');
  shape.node().parentNode.appendChild(shape.node());

  var selection = zoom > 0 ? d : d3.select('.state' + d.properties.state).datum();
  var location = zoom > 0 ? selection.properties.name + ', ' + d3.select('.state' + d.properties.state).datum().properties.code : selection.properties.name;
  d3.select('#table-location').html(location);

  tableMaker(selection);

}

resetShareTable();

function resetShareTable() {
  d3.selectAll('.shape').style('stroke','none');
  tableMaker(d3.select('.nation').datum());
  d3.select('#table-location').html('United States');

}


/* FUNCTION TO CLICK AND ZOOM */

function clicked(d) {

  var selected = d3.select('.state' + d.id);

  if (active.node() === selected.node()) return reset();
  active.classed('active', false);
  active = selected.classed('active', true);

  var bounds = path.bounds(d),
      dx = bounds[1][0] - bounds[0][0],
      dy = bounds[1][1] - bounds[0][1],
      x = (bounds[0][0] + bounds[1][0]) / 2,
      y = (bounds[0][1] + bounds[1][1]) / 2,
      scale = .9 / Math.max(dx / width, dy / height),
      translate = [width / 2 - scale * x, height / 2 - scale * y];

  g.transition()
      .duration(750)
      .attr('transform', 'translate(' + translate + ')scale(' + scale + ')');

  zoom = 1;

}

function reset() {
  active.classed('active', false);
  active = d3.select(null);

  g.transition()
      .duration(750)
      // .style('stroke-width', '1.5px')
      .attr('transform', '');

  zoom = 0;
  resetShareTable();

}
